export const PathAPP = {
  auth: {
    login: '/login',
  },
  job: {
    list: '/job',
    new: '/job/new',
    detail: '/job/:id/detail',
    edit: '/job/:id/edit',
  },
  notification: {
    list: '/notifications',
  },
};
